export interface AuthState {
  token: string | null;
  isLoading: boolean;
  error: string | null;
}

export const ACCESS_TOKEN_KEY = 'inspect_ai_access_token';
